var _a;
export var E_MRZ_LINE;
(function (E_MRZ_LINE) {
    E_MRZ_LINE["LINE_1"] = "line1";
    E_MRZ_LINE["LINE_2"] = "line2";
    E_MRZ_LINE["LINE_3"] = "line3";
})(E_MRZ_LINE || (E_MRZ_LINE = {}));
export var E_TYPE_CARD;
(function (E_TYPE_CARD) {
    E_TYPE_CARD["TD1"] = "TD1";
    E_TYPE_CARD["TD2"] = "TD2";
    E_TYPE_CARD["TD3"] = "TD3";
})(E_TYPE_CARD || (E_TYPE_CARD = {}));
var LINE_1 = {
    disabled: false,
    isError: false,
    infoMessage: '',
};
var LINE_2 = {
    disabled: false,
    isError: false,
    infoMessage: '',
};
var LINE_3 = {
    disabled: false,
    isError: false,
    infoMessage: '',
};
export var DEFAULT_LINES_VALIDATION = (_a = {},
    _a[E_MRZ_LINE.LINE_1] = LINE_1,
    _a[E_MRZ_LINE.LINE_2] = LINE_2,
    _a[E_MRZ_LINE.LINE_3] = LINE_3,
    _a);
